import React from 'react';

import Layout from '../components/Layout';

class KeysBroken extends React.Component {

    render(){
        return(
            <Layout>
                <h1>Report Keys Broken</h1>
            </Layout>
        );
    }
}

export default KeysBroken;